<div class="flex items-center h-[100vh] overflow-hidden">
  <!-- Left Section with Image -->
  <div class="hidden text-center md:w-1/2 md:flex">
    <img
      src="/images/login.png"
      alt="Login Image"
      class="object-cover w-full h-full" />
  </div>

  <!-- Right Section with Form -->
  <p-blockui [target]="pnl" [blocked]="blockedPanel" />
  <div #pnl class="w-[100%] md:w-1/2 flex justify-center items-center h-[100vh]">
        <div class="block w-[90%] md:w-[75%] mx-auto">
      <h2 class="text-center text-[30px] md:text-[40px] font-[35px] font-sans">
        Cladded Glass Broadband
      </h2>
      <h3 class="text-center text-[20px] md:text-[30px] mb-5">Login</h3>
      <div *ngIf="loginFailed" class="content-center w-full m-4 p-field" >
        <span class="content-center w-full text-red-500">
          Username and/or password is incorrect!!
        </span>
      </div>
      <div class="mb-3 p-field">
        <label for="email" class="mb-1">Email</label>
        <input
          class="p-3 text-black bg-white rounded-lg hover:bg-medium_blue-900"
          id="email"
          (blur)="blurred()"
          type="email"
          pInputText
          [(ngModel)]="email"
          placeholder="Enter your email" />
      </div>

      <!-- Password Field -->
      <div class="mb-4 p-field">
        <label for="password">Password</label>
        <input
          class="p-3 text-black bg-white rounded-lg hover:bg-medium_blue-900"
          id="password"
          (keyup.enter)="login()"
          (blur)="blurred()"
          type="password"
          pInputText
          [(ngModel)]="password"
          placeholder="Enter your password" />
      </div>
      <div class="text-sm text-left account-switch">
        <p>
          Forgot your password?
          <a routerLink="/reset" class="switch-link">Reset Password</a>
        </p>
      </div>

      <!-- Login Button -->
      <div class="flex items-center mt-8 mb-4 space-x-5">
        <button
          pButton
          class="p-3 shadow-xs bg-primary-500 hover:bg-medium_blue-800 min-w-48"
          label="Login"
          (click)="login()"></button>
        <span class="p-3 font-semibold">OR</span>
        <button
          pButton
          class="p-3 shadow-xs hover:bg-medium_blue-800 min-w-48"
          (click)="loginWithGoogle()">
          <img src="/icons/google.png" alt="" class="w-[20px]" />
          Login with Google
        </button>
      </div>
      <div class="py-3 text-center account-switch">
        <p>
          Do not have an account?
          <a routerLink="/register" class="switch-link">Register here</a>
        </p>
      </div>
    </div>
</div>
</div>
